import http from "../api/http";
import { get } from "lodash";

import * as actionType from "./actionType";
import { message } from "antd";

import my1 from "@/assets/image/my1.png";
import my2 from "@/assets/image/my2.png";
const getUserInfo = () => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: "GET",
      url: "/web/platform/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        userName: get(res, "data.nickname", ""),
        email: get(res, "data.email", ""),
        userId: get(res, "data.id", ""),
        invitationCode: get(res, "data.invitationCode", ""),
      },
    });

    dispatch({
      type: actionType.UPDATE_MENU_LIST,
      payload: {
        menuList: [
          {
            path: "",
            component: null,
            code: "EMF346",
            children: [
              {
                path: "/user",
                component: "User",
                code: "EMY347",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "用户列表",
                id: 4,
                type: 1,
                parentId: 3,
              },
              {
                path: "/wechat-config",
                component: "WechatConfig",
                code: "EMY348",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "企微配置",
                id: 32,
                type: 1,
                parentId: 3,
              },
            ],
            icon: null,
            name: "用户管理",
            id: 3,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF348",
            children: [
              {
                path: "/score",
                component: "Score",
                code: "EMY349",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "评分指标",
                id: 6,
                type: 1,
                parentId: 5,
              },
              {
                path: "/template",
                component: "Template",
                code: "EMY350",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "通用模板",
                id: 7,
                type: 1,
                parentId: 5,
              },
              {
                path: "/riskModel",
                component: "RiskModel",
                code: "EMY351",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "高风险模型",
                id: 8,
                type: 1,
                parentId: 5,
              },
            ],
            icon: null,
            name: "评分管理",
            id: 5,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF349",
            children: [
              {
                path: "/store-belong",
                component: "StoreBelong",
                code: "EMY360",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "店铺所属列表",
                id: 9,
                type: 1,
                parentId: 8,
              },
              {
                path: "/country",
                component: "Country",
                code: "EMY361",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "国家列表",
                id: 10,
                type: 1,
                parentId: 8,
              },
            ],
            icon: null,
            name: "店铺配置",
            id: 8,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF349",
            children: [
              {
                path: "/package-list",
                component: "PackageList",
                code: "EMY360",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "套餐列表",
                id: 21,
                type: 1,
                parentId: 20,
              },
            ],
            icon: null,
            name: "套餐管理",
            id: 20,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF3031",
            children: [
              {
                path: "/order-list",
                component: "OrderList",
                code: "EMY360",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "订单列表",
                id: 31,
                type: 1,
                parentId: 30,
              },
              {
                path: "/rank-config",
                component: "RankConfig",
                code: "EMY360",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "排行配置",
                id: 33,
                type: 1,
                parentId: 30,
              },
            ],
            icon: null,
            name: "订单管理",
            id: 30,
            type: 3,
            parentId: 0,
          },
          {
            path: "",
            component: null,
            code: "EMF3033",
            children: [
              {
                path: "/benefit-config",
                component: "BenefitConfig",
                code: "EMY333",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "分佣配置",
                id: 35,
                type: 1,
                parentId: 30,
              },
              {
                path: "/payouts-config",
                component: "PayoutsConfig",
                code: "EMY333",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "提现配置",
                id: 34,
                type: 1,
                parentId: 30,
              },
              {
                path: "/payouts-approval",
                component: "PayoutsApproval",
                code: "EMY366",
                children: null,
                selectedIcon: my2,
                unselectedIcon: my1,
                name: "提现审批",
                id: 26,
                type: 1,
                parentId: 33,
              },
            ],
            icon: null,
            name: "系统配置",
            id: 33,
            type: 3,
            parentId: 0,
          },
        ],
      },
    });

    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: false },
    });
  };
};
const changeLoading = (status) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status },
    });
  };
};

const login = (obj) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: "POST",
      url: "/web/platform/auth/login",
      data: {
        ...obj,
      },
    });
    if (res.code === 200) {
      if (!get(res, "data.accessToken", "") || "") {
        message.error("获取token失败");
        return;
      }
      let date = new Date();
      date.setTime(date.getTime() + (res?.data?.expiresIn || 3600) * 1000);

      document.cookie = `token=${
        get(res, "data.accessToken", "") || ""
      }; expires=${date.toUTCString()};`;
      window.location.href = "/";
    }
  };
};

const register = (obj) => {
  return async () => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/auth/register",
      data: {
        ...obj,
      },
    });
    if (res.code === 200) {
      message.success("注册成功");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    }
  };
};

const logout = () => {
  return async () => {
    // const res = await http({
    //   method: 'GET',
    //   url: 'logout',
    //   headers: { urlPrefix: 'login' },
    // });

    // if (res.code === 0) {
    document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
    window.location.href = `/login`;
    // }
  };
};

export { login, logout, getUserInfo, changeLoading, register };
